import {
  Wrapper,
  Image,
  NameDiv,
  Name,
  Action
} from './styled.bussiness-summary';
import brand from '../../../common/images/Business Logo.png';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

function BussinessSummary({ width }) {
  async function handleClick() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('business_domain');
    localStorage.removeItem('user');
    window.location.href = '/login';
  }
  return (
    <MainWrapper width={width}>
      <Image src={brand} />
      <NameDiv width={width}>
        <Name>Bizedge</Name>
        <Action>
          <Link
            to={{ pathname: '/login' }}
            onClick={handleClick}
            style={{ color: '#2898A4' }}
          >
            Sign Out
          </Link>
        </Action>
      </NameDiv>
      <img
        src='https://res.cloudinary.com/dgny8sjrg/image/upload/v1638785992/Bizedge_Frontend_Assets/rightArrow_iiegms.png'
        alt='right arrow'
        className='rightIcon'
      />
    </MainWrapper>
  );
}

export default BussinessSummary;

export const MainWrapper = styled(Wrapper)`
  ${({ width }) => `
    .rightIcon{
      display: ${width ? 'block' : 'none'};
      width: 10px;
      @media (max-width: 960px){
        display: none;
      }
    }
  `}
`;
